import { Notification } from 'element-ui';
import UX from '@/utils/ux';
import errorMessages from '@/modules/form/utils/errorMessages';

export default {
    computed: {
        computedSubmitButtonLabel() {
            return this.isProcessing
                ? 'Please wait...'
                : this.submitButtonLabel
        },

        isProcessing() {
            return this.form.isProcessing;
        }
    },

    methods: {
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },

        validationError(error) {
            return ! _.isEmpty(error.errors) &&  !error.errors.recaptcha;
        },

        formFailure(data, formName = 'elForm') {
            if (this.validationError(data)) {
                this.formValidationFailed(data.errors);
            } else {
                const error = this.getError(data.message);

                return this.$msgbox({
                    message: error.message,
                    type: 'error',
                    title: error.title || 'Something has gone wrong...',
                    confirmButtonText: 'OK',
                    dangerouslyUseHTMLString: true
                });
            }
        },

        getError(error) {
            return errorMessages.translate(error);
        },

        formValidationFailed(errors, formName = 'elForm') {
            _.each(this.$refs[formName].fields, field => {
                const prop = field.$options.propsData.prop;

                const error = errors[prop];

                if (error) {
                    field.validateState = 'error';
                    field.validateMessage = error[0] || 'This field is invalid';
                }
            });

            this.scrollToError(formName);
        },

        notifyGeneralError(message, duration = 0) {
            Notification.error({
                title: 'Opps!',
                message: message,
                duration,
                customClass: 'is-error'
            })
        },

        scrollToError(formName) {
            const firstError = _.find(this.$refs[formName].fields, field => field.validateState === 'error');

            UX.scrollTo(firstError.$el, .5, 50);
        },
    },
}
